<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div
        v-show="showMainList"
        class="main-content"
        type="primary"
      >
        <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search fcl-search-bar">
          <div class="section cargo-advance-search-more">
            <el-form
              label-position="left"
              label-width="80px"
              style="min-width: 830px;margin-right: 10px;"
              :inline="true"
            >
              <el-form-item label="ETD">
                <el-date-picker
                  v-model="filter.startDate"
                  type="date"
                  style="width:98px;"
                  value-format="yyyy-MM-dd"
                  no="1"
                />
                <span style="margin-left: 6px">{{ $t('SeaExport.To') }}</span>
                <el-date-picker
                  v-model="filter.endDate"
                  type="date"
                  style="width:98px;margin-left:6px"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  no="2"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PortOfLoading')">
                <cargo-advance-select
                  :disabled="params.visible"
                  filterable
                  :select-type="selectTypeNames.basic_data_Seaport"
                  tag-name="englishName"
                  tag-value="code"
                  :default-value="filter.loadingPort"
                  clearable
                  style="width: 200px;"
                  no="3"
                  @parentCallBack="p=>{filter.loadingPort=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PortOfDestinationPod')" label-width="100px">
                <cargo-advance-select
                  :disabled="params.visible"
                  filterable
                  :select-type="selectTypeNames.basic_data_Seaport"
                  tag-name="englishName"
                  tag-value="code"
                  :default-value="filter.destinationPort"
                  clearable
                  style="width: 200px;"
                  no="4"
                  @parentCallBack="p=>{filter.destinationPort=p.value}"
                />
              </el-form-item>
              <!--船公司-->
              <el-form-item :label="$t('SeaExport.ShippingCompany')">
                <cargo-company-select
                  :method-params="{companyLob:'seaExport',seaCmp:true,active:true}"
                  :default-value="filter.carrierId||''"
                  :custom-style="'width:200px;'"
                  @change="p=>{filter.carrierId=p.value} "
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Vessel')">
                <cargo-advance-select
                  filterable
                  clearable
                  :select-type="selectTypeNames.basic_data_Vessel"
                  tag-name="englishName"
                  tag-value="vesselId"
                  style="width: 200px"
                  :default-value="filter.vesselId"
                  no="5"
                  @parentCallBack="p=>{filter.vesselId=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')">
                <el-select v-model="filter.routeCode" clearable filterable :placeholder="$t('common.defaultPlaceholder')" no="6">
                  <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item "
                  />
                </el-select>
              </el-form-item>
              <!--航次-->
              <el-form-item :label="$t('CargoMsg.Cargo_VoyageNo')">
                <el-input v-model="filter.voyageNo" no="12" />
              </el-form-item>
              <el-button style="margin-left: 10px" type="primary" no="7" @click="toQuery">
                {{ $t('CargoMsg.Cargo_Query') }}
              </el-button>

              <el-dropdown
                v-show="!params.visible"
                no="8"
                split-button
                type="primary"
                style="margin-left: 10px"
                @click="downloadTemplate()"
                @command="p=>{templateCommand=p;downloadTemplate()}"
              >
                <span v-if="templateCommand === $t('SeaExport.ShippingScheduleold')">{{ $t('SeaExport.ShippingScheduleold') }}</span>
                <span v-if="templateCommand === $t('SeaExport.ShippingScheduleNew')">{{ $t('SeaExport.ShippingScheduleNew') }}</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="$t('SeaExport.ShippingScheduleold')">
                    {{ $t('SeaExport.ShippingScheduleold') }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="$t('SeaExport.ShippingScheduleNew')">
                    {{ $t('SeaExport.ShippingScheduleNew') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-checkbox v-model="filter.nonstop" style="margin-left: 8px;margin-right: 8px" no="nonstop">{{ $t('CargoMsg.Cargo_Nonstop') }}</el-checkbox>
              <el-checkbox v-if="params.pageSource !== 'ocr' " v-model="filter.internationalRoute" style="margin-left: 8px;margin-right: 8px" no="internationalRoute">{{ $t('CargoMsg.Cargo_InternationalRoute') }}</el-checkbox>

              <el-dropdown
                v-show="!params.visible"
                no="8"
                split-button
                type="primary"
                style="margin-left: 10px"
                @command="p=>{importCommand=p}"
              >
                <el-upload
                  v-if="importCommand === $t('SeaExport.ImportOld')"
                  :action="URL.seaExport.importVoyage"
                  :headers="{sessionId, language: $store.getters.language === 'zh' ? 'zh_CN' : ($store.getters.language === 'ja' ? 'ja_JP' : 'en_US')}"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-error="handleError"
                  :on-success="uploadExcelSuccess"
                  :data="{branchId:$store.getters.currentOfficeId}"
                  style="display: inline-block; margin-left: 10px;"
                  no="9"
                >
                  <span style="color: white">{{ $t('SeaExport.ImportOld') }}</span>
                </el-upload>
                <el-upload
                  v-if="importCommand === $t('SeaExport.ImportNew')"
                  :action="URL.seaExport.importVoyageNew"
                  :headers="{sessionId, language: $store.getters.language === 'zh' ? 'zh_CN' : ($store.getters.language === 'ja' ? 'ja_JP' : 'en_US')}"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-error="handleError"
                  :on-success="uploadExcelSuccess"
                  :data="{branchId:$store.getters.currentOfficeId}"
                  style="display: inline-block; margin-left: 5px"
                >
                  <span style="color: white">{{ $t('SeaExport.ImportNew') }}</span>
                </el-upload>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="$t('SeaExport.ImportOld')">
                    <el-upload
                      ref="uploadOld"
                      :action="URL.seaExport.importVoyage"
                      :headers="{sessionId, language: $store.getters.language === 'zh' ? 'zh_CN' : ($store.getters.language === 'ja' ? 'ja_JP' : 'en_US')}"
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :before-upload="beforeOrderUpload"
                      :on-error="handleError"
                      :on-success="uploadExcelSuccess"
                      :data="{branchId:$store.getters.currentOfficeId}"
                      style="display: inline-block; margin-left: 10px;"
                      no="9"
                    >
                      {{ $t('SeaExport.ImportOld') }}
                    </el-upload>
                  </el-dropdown-item>
                  <el-dropdown-item :command="$t('SeaExport.ImportNew')">
                    <el-upload
                      ref="uploadNew"
                      :action="URL.seaExport.importVoyageNew"
                      :headers="{sessionId, language: $store.getters.language === 'zh' ? 'zh_CN' : ($store.getters.language === 'ja' ? 'ja_JP' : 'en_US')}"
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :before-upload="beforeOrderUpload"
                      :on-error="handleError"
                      :on-success="uploadExcelSuccess"
                      :data="{branchId:$store.getters.currentOfficeId}"
                      style="display: inline-block; margin-left: 10px;"
                      no="9"
                    >
                      {{ $t('SeaExport.ImportNew') }}
                    </el-upload>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-button v-show="!params.visible" style="margin-left: 10px" type="primary" no="11" @click="importVoyageResultLog">
                {{ $t('SeaExport.ImportResultLog') }}
              </el-button>
            </el-form>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="310601"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="app-main-inner-row row-pagination">
          <cargo-pagination
            config-module="310601"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
      <import-result
        :visible="importResultDialog.visible"
        :result="importResultDialog.result"
        @continueImporting="continueImporting"
        @close="closeImportResultDialog"
      />
    </div>
  </div></template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getVoyageRouteCode, queryShippingSchedule } from '@/api/voyage'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { queryLastFileDocumentId } from '@/api/seaExport/businessDocument'
import URL from '@/api/urlTranslator'
import ImportResult from '@/views/cargo/v0/SeaExport/Vessel/components/importResult'
import { cache, cacheName } from '@/utils/cacheManager'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import DateUtils from '@/utils/dateUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'TabShipppingSchedule',
  components: { ImportResult, CargoAdvanceSelect, cargoCompanySelect },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      storageURL: '',
      showDetail: false,
      gridParams: {},
      rowData: [],
      fullscreenLoading: null,
      importResultDialog: {
        visible: false,
        result: {}
      },
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      filter: {
        startDate: '',
        endDate: '',
        vesselId: null,
        voyageNo: '',
        nonstop: false,
        internationalRoute: false,
        carrierId: null,
        pageNum: 1,
        pageSize: 50,
        total: 0
      },
      gridOptions: {
        rowSelection: 'single'
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Vessel'), field: 'englishName', colId: 'englishName', width: 100
        },
        {
          headerName: this.$t('SeaExport.Voyage'), field: 'voyageNo', colId: 'voyageNo', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirlineCode'), field: 'routeCode', colId: 'routeCode', width: 100
        },
        {
          headerName: this.$t('SeaExport.BookingShipCallSign'), field: 'callSign', colId: 'callSign', width: 100
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'), field: 'carrierId', colId: 'carrierId', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, this.language)
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfLoading'), field: 'loadingPort', colId: 'loadingPort', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfLoadingArea'), field: 'loadingBerth', colId: 'loadingBerth', width: 100
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'), field: 'destinationPort', colId: 'destinationPort', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDestinationArea'), field: 'destinationBerth', colId: 'destinationBerth', width: 100
        },
        {
          headerName: 'Original ETD', field: 'etd', colId: 'etd', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'Original ETA', field: 'eta', colId: 'eta', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'Current ETD', field: 'currentEtd', colId: 'currentEtd', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'Current ETA', field: 'currentEta', colId: 'currentEta', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'ATD', field: 'atd', colId: 'atd', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: 'ATA', field: 'ata', colId: 'ata', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DocCutOffDate'), field: 'fileCutoff', colId: 'fileCutoff', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CYCutOffDate'), field: 'terminalCutoff', colId: 'terminalCutoff', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CYCutOffDate2'), field: 'customCutoff', colId: 'customCutoff', width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      options: [],
      documentManage: new DocumentManage(),
      selectRowData: {},
      params: {
        visible: false,
        etd: '',
        vesselId: '',
        voyage: '',
        loadingPortCode: '',
        transferPortCode: false,
        dischargingPortCode: '',
        ediCode: '',
        carrierCode: '',
        pageSource: '' // ocr来源：不展示【只看国际航线】、展示【船公司】 高级查询
      },
      templateCommand: this.$t('SeaExport.ShippingScheduleold'),
      importCommand: this.$t('SeaExport.ImportOld')
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    },
    sessionId() {
      return this.$store.getters.token
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('selectShippingScheduleHandle', function(data) {
      self.selectShippingScheduleHandle(data)
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
      getVoyageRouteCode().then(res => {
        if (res.data) {
          this.options = res.data
        }
      })
    },
    toQuery() {
      if (!this.filter.startDate) {
        this.$message.warning(this.$t('SeaExport.PleaseChooseEtdStartDate'))
        return
      }
      if (!this.filter.endDate) {
        this.$message.warning(this.$t('SeaExport.PleaseChooseEtdEndDate'))
        return
      }
      this.fullscreenLoading = getLoading()
      queryShippingSchedule(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.total = parseInt(res.data.total)
        this.fullscreenLoading.close()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    fetchOrderRequirement() {
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      if (currDate && this.filter.startDate) {
        const start = ColumnUtils.dateLabelFunc(currDate)
        const end = ColumnUtils.dateLabelFunc(this.filter.startDate)
        return start < end
      }
    },
    downloadTemplate() {
      switch (this.templateCommand) {
        case this.$t('SeaExport.ShippingScheduleold'):
          ExportUtils.downloadTemplateFile('ImportVoyageTemplate.xls', 'partner')
          break
        case this.$t('SeaExport.ShippingScheduleNew'):
          ExportUtils.downloadTemplateFile('NewImportSchedule.xlsx', 'partner')
          break
      }
    },
    importVoyageResultLog() {
      this.fullscreenLoading = getLoading()
      queryLastFileDocumentId({ documentCategory: '100002', branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.fullscreenLoading.close()
        const fileId = res.data
        if (fileId === '') {
          this.$message.warning(this.$t('SeaExport.NotFindFile'))
          return
        }
        const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
        window.open(url)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    uploadExcelSuccess(response, file, fileList) {
      this.$refs.uploadNew.clearFiles()
      this.$refs.uploadOld.clearFiles()
      this.fullscreenLoading.close()
      if (response && response.data) {
        if (response.data.hasOwnProperty('errorMsg')) {
          this.$message.error(response.data.errorMsg)
          return
        }
        this.importResultDialog.visible = true
        this.importResultDialog.result = response.data
        getVoyageRouteCode().then(res => {
          if (res.data) {
            this.options = res.data
          }
        })
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    beforeOrderUpload(file) {
      this.fullscreenLoading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.fullscreenLoading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.fullscreenLoading.close()
    },
    continueImporting() {
      this.importResultDialog.visible = false
      this.$refs['uploadNew'].$refs['upload-inner'].$refs.input.click()
      this.$refs['uploadOld'].$refs['upload-inner'].$refs.input.click()
    },
    closeImportResultDialog() {
      this.importResultDialog.visible = false
    },
    selectShippingScheduleHandle(data) {
      // 发布事件，将选择的数据返回
      // 通知父组件更新 prop
      this.$emit('callback', data)
    },
    onshow: function(visible, data) {
      if (visible && data) {
        this.filter.nonstop = true
        // 【ocr】进来，不展示【只看国际航线】时，该值设置为false
        this.filter.internationalRoute = this.params.pageSource !== 'ocr'
        if (data.transfering) {
          this.filter.nonstop = false
          this.filter.internationalRoute = false
        }
        this.params.visible = visible
        this.params = data
        if (!this.columnDefs.some(v => v.headerName === this.$t('SeaExport.Operation'))) {
          // 将操作添加到显示列的第一列
          this.columnDefs.unshift({
            headerName: this.$t('SeaExport.Operation'),
            field: 'operation',
            suppressMenu: true,
            hide: false,
            width: 140,
            cellRenderer: params => {
              const text = this.$t('SeaExport.Select')
              const selectShippingScheduleHandle = this.documentManage.getPath('selectShippingScheduleHandle')
              const rowData = JSON.stringify(params.data)
              return `<a href="javascript:void(0)"  style="font-size:10px; border: 1px solid #dcdfe6; background-color: #1c69c0; color: #FFFFFF; padding: 0px 20px; text-decoration: none; display: inline-block; cursor: pointer;" onclick='${selectShippingScheduleHandle}(${rowData})'>${text}</a>`
            }
          })
        }
        if (this.params) {
          if (this.params.etd) {
            this.filter.startDate = this.params.etd
            this.filter.endDate = DateUtils.addDays(this.params.etd, 15)
          }
          this.filter.loadingPort = ''
          if (this.params.loadingPortCode) {
            this.filter.loadingPort = this.params.loadingPortCode
          }
          this.filter.destinationPort = ''
          if (this.params.dischargingPortCode) {
            this.filter.destinationPort = this.params.dischargingPortCode
          }
          if (this.params.vesselId) {
            const vesselId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', this.params.vesselId, 'vesselId')
            if (vesselId) {
              this.$set(this.filter, 'vesselId', vesselId)
            }
          }
          if (this.params.voyageNo) {
            this.filter.voyageNo = this.params.voyageNo
          }
          if (this.params.routeCode) {
            this.$set(this.filter, 'routeCode', this.params.routeCode)
          }
          if (this.params.carrierId) {
            this.filter.carrierId = this.params.carrierId
          }
          // 调用查询
          this.toQuery()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
